export default "../../src/img/defaults/gradient-background.png";